import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { VerificationFailedPage } from '@/features/auth/signup/pages/VerificationFailedPage.tsx';
import { authRoute } from '@/App.tsx';

const searchSchema = z.object({
  reason: z.string().optional(),
});

export const verificationFailedRoute = createRoute({
  getParentRoute: () => authRoute,
  path: '/verification-failed',
  component: VerificationFailedPage,
  validateSearch: searchSchema,
});
